import { useEffect, useState } from 'react'
import { Card, CardContent, Grid, TextField } from "@mui/material"
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { post } from '../../../utils/axios'
import Button from '../../../components/Button'

const EditChildren = () => {

    const navigate = useNavigate()
    const {childId} = useParams()

    const [isLoading,setIsLoading] = useState(false)
    const [child,setChild] = useState({firstName: '',lastName: '',nationalCode: '',mobile: ''})

    useEffect(() => {
        const postedData = {
            userId: childId
        }
        post('ChildUser/GetChildUserByUserId',postedData).then(({data}) => {
            if(data.isSuccess)
                setChild({...data.data})
            else
                toast.error(data.message)
        })
    },[])

    const editChild = () => {
        setIsLoading(true)
        const postedData = {
            id: childId,
            firstName: child.firstName,
            lastName: child.lastName
        }
        post('ChildUser/UpdateChildUser',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('شریک مورد نظر با موفقیت به روزرسانی شد')
                navigate(-1)
            }else
                toast.error(data.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        if(child.mobile && child.mobile.length){
            if(child.mobile.includes('۰'))
                setChild({...child,mobile: child.mobile.replace(/۰/g,'0')})
            if(child.mobile.includes('۱'))
                setChild({...child,mobile: child.mobile.replace(/۱/g,'1')})
            if(child.mobile.includes('۲'))
                setChild({...child,mobile: child.mobile.replace(/۲/g,'2')})
            if(child.mobile.includes('۳'))
                setChild({...child,mobile: child.mobile.replace(/۳/g,'3')})
            if(child.mobile.includes('۴'))
                setChild({...child,mobile: child.mobile.replace(/۴/g,'4')})
            if(child.mobile.includes('۵'))
                setChild({...child,mobile: child.mobile.replace(/۵/g,'5')})
            if(child.mobile.includes('۶'))
                setChild({...child,mobile: child.mobile.replace(/۶/g,'6')})
            if(child.mobile.includes('۷'))
                setChild({...child,mobile: child.mobile.replace(/۷/g,'7')})
            if(child.mobile.includes('۸'))
                setChild({...child,mobile: child.mobile.replace(/۸/g,'8')})
            if(child.mobile.includes('۹'))
                setChild({...child,mobile: child.mobile.replace(/۹/g,'9')})
        }
    },[child.mobile])

    useEffect(() => {
        if(child.nationalCode && child.nationalCode.length){
            if(child.nationalCode.includes('۰'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۰/g,'0')})
            if(child.nationalCode.includes('۱'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۱/g,'1')})
            if(child.nationalCode.includes('۲'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۲/g,'2')})
            if(child.nationalCode.includes('۳'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۳/g,'3')})
            if(child.nationalCode.includes('۴'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۴/g,'4')})
            if(child.nationalCode.includes('۵'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۵/g,'5')})
            if(child.nationalCode.includes('۶'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۶/g,'6')})
            if(child.nationalCode.includes('۷'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۷/g,'7')})
            if(child.nationalCode.includes('۸'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۸/g,'8')})
            if(child.nationalCode.includes('۹'))
                setChild({...child,nationalCode: child.nationalCode.replace(/۹/g,'9')})
        }
    },[child.nationalCode])

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">ویرایش شریک</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%',mb: 2 }}>
                    <CardContent sx={{ py: 3,pb: 4 }}>
                        <TextField label="نام" variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setChild({...child,firstName: e.target.value})} value={child.firstName} />
                        <TextField label="نام خانوادگی" variant="standard" fullWidth sx={{mb: 2.5}} onChange={e => setChild({...child,lastName: e.target.value})} value={child.lastName} />
                        <TextField label="شماره همراه" disabled type="tel" className="ltr-input" inputProps={{maxLength: 11}} variant="standard" fullWidth sx={{mb: 2.5 }} onChange={e => setChild({...child,mobile: e.target.value})} value={child.mobile} />
                        <TextField label="کد ملی" disabled type="tel" className="ltr-input" inputProps={{maxLength: 10}} variant="standard" fullWidth sx={{mb: 2.5 }} onChange={e => setChild({...child,nationalCode: e.target.value})} value={child.nationalCode} />
                        <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!child.firstName || !child.lastName || !child.mobile || !child.mobile.startsWith('09') || child.mobile.length != 11 || !child.nationalCode || child.nationalCode.length != 10} onClick={editChild}>به روزرسانی شریک</Button>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default EditChildren